import React, { Suspense, lazy } from 'react';
import { CircularProgress } from '../components/CircularProgress';

export default importLoader => {
	const LoadedComponent = lazy(importLoader);

	return props => {
		return (
			<Suspense fallback={<CircularProgress centered />}>
				<LoadedComponent {...props} />
			</Suspense>
		);
	};
};
